import React from 'react';
import { List, Avatar, theme } from 'antd';
import { SettingFilled, CheckSquareFilled, CloseSquareOutlined } from '@ant-design/icons';

import { PointInTime } from '../../../components/PointInTime';

const renderUnit = (value: number, unit?: string, units?: string) => {
  if (typeof value !== 'number') return '';

  if (unit && value <= 1) return ` ${unit}`;
  if (units && value > 1) return ` ${units}`;
};

function Icon({ CustomIconComponent, value }: { CustomIconComponent?: React.ComponentType<any>; value: boolean }) {
  const { token } = theme.useToken();

  if (CustomIconComponent) return <CustomIconComponent style={{ color: token.colorPrimary }} />;

  if (value === true) return <CheckSquareFilled style={{ color: token.colorPrimary }} />;
  if (value === false) return <CloseSquareOutlined style={{ color: token.colorPrimary }} />;

  return <SettingFilled style={{ color: token.colorPrimary }} />;
}

export type AuditLogListItemProps = {
  item: {
    modifiedBy: string;
    name: string;
    value: boolean;
    unit?: string;
    units?: string;
    type?: string;
    modifiedAt: string;
    CustomIconComponent?: React.ComponentType<any>;
  };
};

function AuditLogListItem({ item }: AuditLogListItemProps) {
  const title = React.useMemo(() => {
    const { modifiedBy, name, value, unit, units, type } = item;
    let title = '';
    if (value === true) title = `${modifiedBy} enabled ${name}.`;
    else if (value === false) title = `${modifiedBy} disabled ${name}.`;
    else if (type === 'coupon') title = `${modifiedBy} ${value}.`;
    else if (type === 'referral') title = `${modifiedBy} ${value}.`;
    else title = `${modifiedBy} set the ${name} to ${value}${renderUnit(value, unit, units)}.`;
    return title;
  }, [item]);

  return (
    <List.Item>
      <List.Item.Meta
        avatar={
          <Avatar
            icon={<Icon CustomIconComponent={item.CustomIconComponent} value={item.value} />}
            style={{ background: 'transparent' }}
          />
        }
        title={title}
        description={<PointInTime value={item.modifiedAt} />}
      />
    </List.Item>
  );
}

export default AuditLogListItem;
